import { MAX_FLOOR } from './constants';

/** Up to two letters, optional hyphen, 1–4 digits. Examples: 101, A-101, B1203. */
export const UNIT_NUMBER_PATTERN = /^[A-Z]{0,2}-?\d{1,4}$/;

/** Trim, uppercase and remove internal whitespace. Does not validate. */
export function normalizeUnitNumber(raw: string): string {
  return raw.trim().toUpperCase().replace(/\s+/g, '');
}

export function isValidUnitNumber(raw: string): boolean {
  return UNIT_NUMBER_PATTERN.test(normalizeUnitNumber(raw));
}

/**
 * Floor from the numeric part of a unit number: ⌊n / 100⌋ when it has 3+ digits
 * (101 → 1, B1203 → 12, G-005 → 0), otherwise null ("Floor not set").
 */
export function deriveFloor(unitNumber: string): number | null {
  const digits = normalizeUnitNumber(unitNumber).match(/\d+/)?.[0];
  if (!digits || digits.length < 3) return null;
  const floor = Math.floor(Number(digits) / 100);
  return floor <= MAX_FLOOR ? floor : null;
}

export function floorLabel(floor: number | null | undefined): string {
  if (floor === null || floor === undefined) return 'Floor not set';
  if (floor === 0) return 'Ground floor';
  return `Floor ${floor}`;
}

/** Natural sort for unit numbers: "A-2" < "A-10". */
export function compareUnitNumbers(a: string, b: string): number {
  return a.localeCompare(b, 'en', { numeric: true, sensitivity: 'base' });
}
